const pinTypes = {
  crc: 'a',
  cre: 'b',
  combined: 'c',
  user: 'd'
}

const mapDefaults = {
  zoom: 5.75,
  center: {
    lat: -32.571375,
    lng: 149.543516
  }
}

const searchDefaults = {
  // these bounds are the points that draw a rectangle around NSW
  bounds: {
    sw: {
      lat:  -37.5050296,
      lng:  140.9995018
    },
    ne: {
      lat:  -28.1576018,
      lng:  153.6365661
    }
  }
}

interface searchRestrictionsProps {
  types?: string[],
  fields?: string[],
  strictBounds?: boolean,
  bounds?: google.maps.LatLngBounds | undefined,
  address?: string | undefined,
  componentRestrictions?: {
    country?: string
  }
}

const geoCodeRestrictions:searchRestrictionsProps = {
  address: undefined,
  componentRestrictions: { country: 'au' },
  bounds: undefined,
}


const searchRestrictions:searchRestrictionsProps =  {
  componentRestrictions: { country: 'au' },
  types: ['geocode'],
  fields: ['geometry', 'name', 'formatted_address', 'type'],
  bounds: undefined,
  // stops anything from outside the bounds we set from being shown in the autocomplete.
  strictBounds: true
};

const listDefaults = {
  perPage: 10
}

const filterDefaults = {
  itemsToShow: 5
}

type TitleMapProps = {
  [key: string] : string
}

const titleMap:TitleMapProps = {
  crc: 'Community Recycling Centre',
  cre: 'Chemical Cleanout Event'
}

const view = {
  pageTitle: 'Community Recycling Centres',
  panelView: 'map'
}

const config = {
  namespace: 'crc',
  pinTypes,
  view,
  map: mapDefaults,
  list: listDefaults,
  filters: filterDefaults,
  search: searchDefaults,
  titleMap
}

const mapRoot = 'crc-map-root'

export  {
  mapRoot,
  config,
  pinTypes,
  searchRestrictions,
  geoCodeRestrictions
}
